
export interface ControlElement extends HTMLElement {
	canSubmit: () => ICanSubmitResult,
}

export interface IProps {
	canSubmit: () => ICanSubmitResult,
}

export interface ICanSubmitResult {
	warningMessage?: string;
	errorMessage?: string;
}


export default function init(ref: React.RefObject<HTMLElement>, props: IProps) {
	if (ref.current) {
		ref.current.classList.add("qd-react-root-control");
		(ref.current as any).canSubmit = props.canSubmit;
	}
}